import { Injectable } from "@angular/core";
import { NestApiProvider, FormDataUpload } from "../../nest-api";
import { RequestRecordFace, RequestDevice, ResponseDevice, ResponseListingUserTenant, ResponseAttendanceTempDetailLoc, RequestSaveUserTenant, RequestSaveCompanyTenant, RequestListingCompanyTenant, RequestAttendanceTempLog, RequestListingTimeZone } from "../dto/face-thermal.dto";
import { Observable } from "rxjs";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class FaceThermalApi {

    private service: string = 'attendanceFaceRecognize';
    private model: string = 'attendanceFaceRecognize';

    constructor(
        private nestApiProvider: NestApiProvider,
        private http: HttpClient
    ) {

    }

    public saveRecordFace(payload: RequestRecordFace): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'faceRecognize';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public saveDeviceHost(payload: { urlDevice: any }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'registerDeviceHost';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public saveDevice(payload: RequestDevice): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'saveFacedevice';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getEmpTigersoft(payload): Observable<ResponseData<ResponseDevice[]>> {
        const method: string = 'GET';
        const func: string = 'getEmployee';
        const params: any = {};
        const urlParams: any = {
            machineCode : payload
        };
        const body: any = {};
        const model : string = 'tigersoft'

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<ResponseDevice[]>>(method, url, params, urlParams, body);
    }

    public getDevice(): Observable<ResponseData<ResponseDevice[]>> {
        const method: string = 'GET';
        const func: string = 'getFacedevice';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<ResponseDevice[]>>(method, url, params, urlParams, body);
    }

    public getDeviceTigersoft(): Observable<ResponseData<ResponseDevice[]>> {
        const method: string = 'GET';
        const func: string = 'getDevice';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};
        const model : string = 'tigersoft'

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<ResponseDevice[]>>(method, url, params, urlParams, body);
    }

    public notQualified(payload: { id: string }): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'notQualified';
        const params: any = {};
        const urlParams: any = payload;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public syncFaceUserFromProfile(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'syncFaceUserFromProfile';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public listingUserTenant(payload: { page: number, limit: number }): Observable<ResponsePaging<ResponseListingUserTenant>> {
        const method: string = 'GET';
        const func: string = 'listingUserTenant';
        const params: any = {};
        const urlParams: any = payload;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponsePaging<ResponseListingUserTenant>>(method, url, params, urlParams, body);
    }

    public listingCompanyTenant(payload: { page: number, limit: number }): Observable<ResponsePaging<RequestListingCompanyTenant>> {
        const method: string = 'GET';
        const func: string = 'listingCompanyTenant';
        const params: any = {};
        const urlParams: any = payload;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponsePaging<RequestListingCompanyTenant>>(method, url, params, urlParams, body);
    }

    public attendanceTempDetailLoc(payload: RequestAttendanceTempLog): Observable<ResponsePaging<ResponseAttendanceTempDetailLoc>> {
        const method: string = 'POST';
        const func: string = 'attendanceTempDetailLoc';
        const params: any = {
          personId: payload.personId,
          empId: payload.empId,
          companyId: payload.companyId
        };
        const urlParams: any = payload;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponsePaging<ResponseAttendanceTempDetailLoc>>(method, url, params, urlParams, body);
    }

    public saveUserTenant(payload: RequestSaveUserTenant): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'saveUserTenant';
        const params: any = payload
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public saveCompanyTenant(payload: RequestSaveCompanyTenant): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'saveCompanyTenant';
        const params: any = payload
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public removeDevice(payload: { id: any }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'deleteFacedevice';
        const params: any = payload;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getUserPhotos(personId: any): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getUserPhotos';
        const params: any = {};
        const urlParams: any = {
            personId: personId
        };
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getUserNotInDevice(persons: any, type?: any, filterId?: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'getUserNotInDevice';
        const params: any = {
            ids: persons,
            type: type,
            filterId: filterId
        };
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getGuestNotInDevice(persons: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'getGuestNotInDevice';
        const params: any = {
            ids: persons,
        };
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getTenantNotInDevice(persons: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'getTenantNotInDevice';
        const params: any = {
            ids: persons,
        };
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public addUserPhoto(personId: any, name: File): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'addUserPhoto';
        const params: FormDataUpload[] = [];
        params.push({ name: 'photo', value: name });
        params.push({ name: 'personId', value: personId });
        const urlParams: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.requestUpload<ResponseData<any>>(method, url, params);
    }

    public deleteUserPhoto(personId: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'deleteUserPhoto';
        const params: any = {
            id: personId,
        };
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }


    public getLatestPhoto(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getLatestPhoto';
        const params: any = {};
        const urlParams: any = {}
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public expiredGuest(date): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const model: string = 'thermalDashboardUserlogins';
        const func: string = 'expiredGuest';
        const params: any = {};
        const urlParams: any = { date: date }
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    urlAddUserPhoto() {
        const method: string = 'POST';
        const func: string = 'addUserPhoto';
        const params: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, {}, this.model);
        return url;
    }

    urlUploadMultipleTigersoft() {
        const method: string = 'POST';
        const func: string = 'batchUpload';
        const model: string = 'tigersoft'
        const params: any = {};
        const url = this.nestApiProvider.urlBuilder(method, model, func, params, {}, model);
        return url;
    }

    urlUploadMultiple() {
        const method: string = 'POST';
        const func: string = 'batchUpload';
        const params: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, {}, this.model);
        return url;
    }

    urlUploadMultipleTenant() {
        const method: string = 'POST';
        const func: string = 'tenantUploadPhoto';
        const params: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, {}, this.model);
        return url;
  }

    getLogoGreatday() {
        return this.http.get('../../assets/images/logo-greatday.png', { responseType: 'blob', observe: 'response' });
    }

    public listingTimeZone(): Observable<ResponsePaging<RequestListingTimeZone>> {
        const method: string = 'GET';
        const func: string = 'getAllTimeZone';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};
        const model: string = 'timezone';
  
        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        console.log(url);
  
        return this.nestApiProvider.request<ResponsePaging<RequestListingTimeZone>>(method, url, params, urlParams, body);
    }

    public zktecoSyncUser(ids: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'syncEmployeeToZkteco';
        const params: any = {
          userIds: ids
        };
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public syncUserTigersoft(userIds, machineCode): Observable<ResponseData<any>> {
        console.log(userIds, machineCode);
        
        const method: string = 'POST';
        const func: string = 'addEmployee';
        const params: any = {
          userIds: userIds,
          machineCode: machineCode
        };
        const urlParams: any = {};
        const body: any = {};
        const model: string = 'tigersoft';

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public deleteTigersoft(userIds, machineCode, deleteTigersoft): Observable<ResponseData<any>> {
        console.log(userIds, machineCode);
        
        const method: string = 'POST';
        const func: string = 'deleteEmployee';
        const params: any = {
          userIds: userIds,
          machineCode: machineCode,
          deleteTigersoft: deleteTigersoft
        };
        const urlParams: any = {};
        const body: any = {};
        const model: string = 'tigersoft';

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public deleteAllTigersoft(userIds, machineCode, deleteTigersoft): Observable<ResponseData<any>> {
        console.log(userIds, machineCode);
        
        const method: string = 'POST';
        const func: string = 'deleteEmployee';
        const params: any = {
          userIds: userIds,
          machineCode: machineCode,
          deleteTigersoft: deleteTigersoft
        };
        const urlParams: any = {};
        const body: any = {};
        const model: string = 'tigersoft';

        const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getWorkLocation(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getWorkLocation';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getDepartment(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getDepartment';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }
}





// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/face-thermal.api.ts